import {
  isEmpty, isNumber, isObject, mapValues, omitBy,
} from 'lodash';

type IPayloadValue = Record<string, any>;

const checkNested = (value: string | IPayloadValue | undefined): string | IPayloadValue | undefined => {
  if (isObject(value) && !Array.isArray(value)) {
    const cleaned = mapValues(omitBy(value, isEmpty), checkNested);
    return isEmpty(cleaned) ? undefined : cleaned;
  }
  return value;
};

export const getCleanedPayload = <T = IPayloadValue>(data: T): T => mapValues(
  omitBy(data as Partial<T>, (v) => {
    if (isNumber(v)) return false;
    return isEmpty(v) || (isObject(v) && isEmpty(checkNested(v)));
  }),
  checkNested,
) as T;
